import { warn } from "@swivl-mono/helpers";
import { AppInterface } from "@swivl-mono/types";
import { Input, Spinner } from "@swivl-mono/ui";
import React from "react";

import { ConversationRestrictionsControls } from "../../../../Components/ConversationRestrictionsControls/ConversationRestrictionsControls";
import AppsModel from "../../../../Models/Apps/Apps.Model";
import { NavBar } from "../../../../Models/NavBar/NavBar.Model";

interface Props {
  app: AppInterface;
  selected?: boolean;
}

export default class WhatsAppView extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentWillMount() {
    NavBar.set(<NavBar.Component.Back />, <NavBar.Component.Title> WhatsApp App Settings</NavBar.Component.Title>, null);
  }

  componentDidMount() {
    // Initialize Facebook SDK
    (window as any).fbAsyncInit = () => {
      (window as any).FB.init({
        appId: "494256942985946",
        autoLogAppEvents: true,
        xfbml: true,
        version: "v21.0"
      });
    };

    // Load Facebook SDK script
    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    window.addEventListener("message", (event) => {
      if (event.origin !== "https://www.facebook.com") return;
      try {
        const data = JSON.parse(event.data);
        if (data.type === "WA_EMBEDDED_SIGNUP") {
        }
      } catch {
        warn("error");
      }
    });
  }

  onChange(e) {
    const app = { ...this.props.app };
    const name = e.target.name;
    const value = e.target.value;
    if (name === "businessAccountId") {
      app.identifier = value;
    } else {
      let token = app.token || {};
      token[name] = value;
      app.token = token;
    }

    AppsModel.update(app, false);
  }
  onBlur(e) {
    AppsModel.update(this.props.app, true);
  }

  render() {
    const { app } = this.props;

    const token = app.token || {};
    const businessAccountId = app.identifier || "";

    if (!app) {
      return <Spinner />;
    } else {
      return (
        <div className="WhatsAppView">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRt934kGoOexJHiaxs1wvKI4rne1giC0FiagQ&s"
            width={389}
            height={179}
            style={{
              background: "none"
            }}
          />
          {/* <div className="whatsappValues">
            <label>Phone Number ID</label>
            <Input
              name="phoneNumberId"
              value={token.phoneNumberId}
              onChange={this.onChange}
              onBlur={this.onBlur}
            />
            <label>Phone Number (ie. +17205551234)</label>
            <Input
              name="phoneNumber"
              value={token.phoneNumber}
              onChange={this.onChange}
              onBlur={this.onBlur}
            />
            <label>Business Account ID</label>
            <Input
              name="businessAccountId"
              value={businessAccountId}
              onChange={this.onChange}
              onBlur={this.onBlur}
            />
            <label>Access Token</label>
            <Input
              type={Input.Type.Password}
              name="accessToken"
              value={token.accessToken}
              onChange={this.onChange}
              onBlur={this.onBlur}
            />
          </div> */}

          <hr className="mt-5 mb-5" />
          <ConversationRestrictionsControls
            restrictionsData={app.data?.locationRestrictions || {}}
            updateRestrictionsData={(data) => {
              const app = { ...this.props.app };
              app.data.locationRestrictions = data;
              AppsModel.update(app, true);
            }}
          />
        </div>
      );
    }
  }
}
